import 'imagesloaded';
import 'jquery-match-height';

const $attributeSets = $('.specifications .attribute-set');
if ($attributeSets.length) {
  const self = {};

  /** Initialise the module. */
  self.initialise = function initialise() {
    $attributeSets.imagesLoaded(() => {
      const $attributeSetHeaders = $attributeSets.find('.attribute-set__header');

      // Equalise the headers.
      if ($attributeSetHeaders.length) {
        $attributeSetHeaders.matchHeight({
          byRow: false,
          property: 'height',
          target: null,
          remove: false,
        });
      }

      // Equalise the full container.
      $attributeSets.matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
      });
    });
  };

  self.initialise();
}
